import { AddAnchorVwapButtonComponent } from "./components/menu/add-anchor-vwap-button.component";
import { AddComparisonSymbolsButtonComponent } from "./components/menu/add-comparison-symbols-button.component";
import { AddIndicatorsButtonComponent } from "./components/menu/add-indicators-button.component";
import { AddPriceAlertButtonComponent } from "./components/menu/add-price-alert-button.component";
import { BuyButtonWithCurrentPriceMenuComponent } from "./components/menu/buy-button-with-current-price-menu.component";
import { BuyButtonWithTradeQuoteComponent } from "./components/menu/buy-button-with-trade-quote.component";
import { BuyButtonComponent } from "./components/menu/buy-button.component";
import { CameraScrenshotComponent } from "./components/menu/camera-screnshot.component";
import { ChartTypeComponent } from "./components/menu/chart-type.component";
import { HeartStatusComponent } from "./components/menu/heart-status.component";
import { HighChartIndicatorsComponent } from "./components/menu/highchart-indicators.component";
import { SellButtonWithCurrentPriceMenuComponent } from "./components/menu/sell-button-with-current-price-menu.component";
import { SellButtonWithTradeQuoteComponent } from "./components/menu/sell-button-with-trade-quote.component";
import { SellButtonComponent } from "./components/menu/sell-button.component";
import { SymbolLookupComponent } from "./components/menu/symbol-lookup.component";
import { TimeframeIconComponent } from "./components/menu/timeframe-icon.component";
import { ToolIconComponent } from "./components/menu/tool-icon.component";
import { TradeIconComponent } from "./components/menu/trade-icon.component";
import { QuickOrdersComponent } from "./components/menu/quick-orders.component";
import { TradeOrderTypeComponent } from "./components/menu/trade-order-type.component";
import { StringHelpers } from "./helpers/string-helpers";
import { IChartContainer } from "./models/base/chart-container.interface";

export class TiChartMenuContainer {
    private id = StringHelpers.newGuid();
    
    private tiChartContainer: IChartContainer;
    private toolIconComponent: ToolIconComponent;
    private highChartsIndicatorsComponent: HighChartIndicatorsComponent;
    private timeframeComponent: TimeframeIconComponent;
    private element: HTMLElement;

    public displayTools = false;
    public displayTimeframe = false;
    public displayChartType = false;
    public displayIndicator = false;
    public displayTradeOrderType = false;

    private preventScreenClick = false;

    constructor(el: HTMLElement, tiChartContainer: IChartContainer) {
        this.element = el;
        this.tiChartContainer = tiChartContainer;

        if (this.tiChartContainer.marketingWebChartMode || this.tiChartContainer.pnpMode) {    
            this.createTimeframeIconComponent();
            this.onBodyClick();

            if (!this.tiChartContainer.pnpMode && !this.tiChartContainer.isPreview) {
                this.createMarketingWebChartHighChartIndicatorsComponent();
                this.createBuyButtonWithCurrentPriceMenuComponent();
                this.createSellButtonWithCurrentPriceMenuComponent();
                this.createTradeIconComponent();
                this.createTradeQuickOrdersComponent();
                // this.createTradeOrderTypeComponent();

                if (!this.tiChartContainer.isTouchDevice) {
                    this.createToolIconComponent();
                }
            }
            
            return;
        }
        this.createChartTypeComponent();
        this.createSymbolLookupComponent();
        this.createHighChartIndicatorsComponent();
        this.createToolIconComponent();
        this.createTimeframeIconComponent();
        this.createBuyButtonComponent();
        this.createSellButtonComponent();
        this.createBuyButtonWithTradeQuoteComponent();
        this.createSellButtonWithTradeQuoteComponent();
        this.createAddIndicatorsButtonComponent();
        this.createAddPriceAlertButtonComponent();
        this.createAddAnchorVwapButtonComponent();
        this.createAddComparisonSymbolsButtonComponent();
        this.createHeartStatusComponent();
        this.createCameraScreenshotComponent();
        this.createTradeIconComponent();
        this.createTradeOrderTypeComponent();
        this.onBodyClick();
    }

    private createChartTypeComponent() {
        this.element.querySelectorAll<HTMLElement>('.chart-type').forEach((el: HTMLElement) => {
            const chartTypeComponent = new ChartTypeComponent(el, this.tiChartContainer, this);
            this.tiChartContainer.components.push(chartTypeComponent);
        });
    }

    private createMarketingWebChartHighChartIndicatorsComponent() {
        this.element.parentElement?.querySelectorAll<HTMLElement>('.indicator').forEach((el: HTMLElement) => {
            this.highChartsIndicatorsComponent = new HighChartIndicatorsComponent(el, this, this.tiChartContainer);
            this.tiChartContainer.components.push( this.highChartsIndicatorsComponent);
        });
    }

    private createHighChartIndicatorsComponent() {
        this.element.querySelectorAll<HTMLElement>('.indicator').forEach((el: HTMLElement) => {
            this.highChartsIndicatorsComponent = new HighChartIndicatorsComponent(el, this, this.tiChartContainer);
            this.tiChartContainer.components.push( this.highChartsIndicatorsComponent);
        });
    }

    private createSymbolLookupComponent() {
        const symbolLookupComponent = new SymbolLookupComponent(this.tiChartContainer);
        this.tiChartContainer.components.push(symbolLookupComponent);
    }

    private createToolIconComponent() {
        this.toolIconComponent = new ToolIconComponent(this, this.tiChartContainer);
        this.tiChartContainer.components.push(this.toolIconComponent);
    }

    private createTimeframeIconComponent() {
        this.element.querySelectorAll<HTMLElement>('.controls .time').forEach((el: HTMLElement) => {
            this.timeframeComponent = new TimeframeIconComponent(el, this, this.tiChartContainer);
            this.tiChartContainer.components.push(this.timeframeComponent);
        });
    }

    private createBuyButtonComponent() {
        this.element.querySelectorAll<HTMLElement>('.buy-sell-buttons-container.normal .buy').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new BuyButtonComponent(el, this.tiChartContainer));
        });
    }

    private createSellButtonComponent() {
        this.element.querySelectorAll<HTMLElement>('.buy-sell-buttons-container.normal .sell').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new SellButtonComponent(el, this.tiChartContainer));
        });
    }

    private createBuyButtonWithTradeQuoteComponent() {
        this.element.querySelectorAll<HTMLElement>('.buy-sell-buttons-container.trade-quote .buy').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new BuyButtonWithTradeQuoteComponent(el, this.tiChartContainer));
        });
    }

    private createSellButtonWithTradeQuoteComponent() {
        this.element.querySelectorAll<HTMLElement>('.buy-sell-buttons-container.trade-quote .sell').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new SellButtonWithTradeQuoteComponent(el, this.tiChartContainer));
        });
    }

    private createBuyButtonWithCurrentPriceMenuComponent() {
        this.tiChartContainer.element.querySelectorAll<HTMLElement>('.main-symbol-current-price-menu-items .buy').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new BuyButtonWithCurrentPriceMenuComponent(el, this.tiChartContainer));
        });
    }

    private createSellButtonWithCurrentPriceMenuComponent() {
        this.tiChartContainer.element.querySelectorAll<HTMLElement>('.main-symbol-current-price-menu-items .sell').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new SellButtonWithCurrentPriceMenuComponent(el, this.tiChartContainer));
        });
    }

    private createAddIndicatorsButtonComponent() {
        this.element.querySelectorAll<HTMLElement>('.add-indicators-button').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new AddIndicatorsButtonComponent(el, this.tiChartContainer));
        });
    }

    private createAddPriceAlertButtonComponent() {
        this.element.querySelectorAll<HTMLElement>('.add-price-alert-button').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new AddPriceAlertButtonComponent(el, this.tiChartContainer));
        });
    }

    private createAddAnchorVwapButtonComponent() {
        this.element.querySelectorAll<HTMLElement>('.add-anchor-vwap-button').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new AddAnchorVwapButtonComponent(el, this.tiChartContainer));
        });
    }

    private createAddComparisonSymbolsButtonComponent() {
        this.element.querySelectorAll<HTMLElement>('.add-comparion-symbols-button').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new AddComparisonSymbolsButtonComponent(el, this.tiChartContainer));
        });
    }

    private createHeartStatusComponent() {
        this.element.querySelectorAll<HTMLElement>('.heart-status-button').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new HeartStatusComponent(el, this.tiChartContainer));
        });
    }

    private createCameraScreenshotComponent() {
        this.element.querySelectorAll<HTMLElement>('.camera-screenshot-button').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new CameraScrenshotComponent(el, this.tiChartContainer));
        });
    }

    private createTradeIconComponent() {
        this.element.querySelectorAll<HTMLElement>('.trade-button').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new TradeIconComponent(el, this.tiChartContainer));
        });
    }

    private createTradeQuickOrdersComponent() {
        this.element.querySelectorAll<HTMLElement>('.trade-quick-orders').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new QuickOrdersComponent(el, this.tiChartContainer));
        });
    }

    private createTradeOrderTypeComponent() {
        this.tiChartContainer.element.querySelectorAll<HTMLElement>('.trade-order-type').forEach((el: HTMLElement) => {
            this.tiChartContainer.components.push(new TradeOrderTypeComponent(el, this.tiChartContainer, this));
        });
    }

    public toggleControls() {
        let checkChartHeightForCollapsePIP = false;
        const tools = this.element.findParents('.main-chart')?.querySelector('.highcharts-stocktools-wrapper');
        if (tools) {
            if (this.displayTools) {
                this.toolIconComponent?.show();
            } else {
                this.toolIconComponent?.hide();
            }
        }

        if (this.displayTimeframe) {
            checkChartHeightForCollapsePIP = true;
            this.timeframeComponent?.show();
        } else {
            this.timeframeComponent?.hide();
        }
        
        const chartType = this.element.querySelector('.controls .chart-type');
        if (chartType) {
            if (this.displayChartType) {
                checkChartHeightForCollapsePIP = true;
                chartType.classList.add('active');
            } else {
                chartType.classList.remove('active');
            }
        }

        const tradeOrderType = this.element.querySelector('.controls .trade-order-type');
        if (tradeOrderType) {
            if (this.displayTradeOrderType) {
                tradeOrderType.classList.add('active');
            } else {
                tradeOrderType.classList.remove('active');
            }
        }

        if (this.displayIndicator) {
            checkChartHeightForCollapsePIP = true;
            this.highChartsIndicatorsComponent?.show();
        } else {
            this.highChartsIndicatorsComponent?.hide();
        }

        if (!this.tiChartContainer.marketingWebChartMode && !this.tiChartContainer.pnpMode && checkChartHeightForCollapsePIP) {
            // this.element.findFirst('.pnp-on-off-arrow .arrow')?.click();
            const pnp = document.querySelector<HTMLElement>('.ti-chart.pnp');
            if (this.tiChartContainer.tiChartSeries?.chartElement?.clientHeight <= 450 && pnp && pnp.classList.contains('show')) {
                this.preventScreenClick = true;
                pnp.findFirst('.pnp-on-off-arrow .arrow')?.click();

                setTimeout(() => {
                    this.preventScreenClick = false;
                }, 350);
            }
        }
    }

    public closeAllMenuControls() {
        if (this.preventScreenClick)  {
            return;
        }

        this.displayChartType = false;
        // this.displayTools = false;
        this.displayIndicator = false;
        this.displayTimeframe = false;
        this.displayTradeOrderType = false;
        this.toggleControls();
    }

    private onBodyClick() {
        this.tiChartContainer.domEvents.onScreenClick(this.id, () => {
            this.closeAllMenuControls();
        });
    }
}